import React, { type PropsWithChildren } from 'react'
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

import 'dayjs/locale/ru'

dayjs.locale('ru')
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(isBetween)

export const WithDayjs: React.FC<PropsWithChildren> = ({ children }) => {
    return <>{children}</>
}
